import { Component, OnInit, Input, OnDestroy, ViewEncapsulation, HostListener, ViewChild, AfterViewInit, AfterViewChecked, ElementRef, Output, EventEmitter } from '@angular/core';
import OlMap from 'ol/Map';
import OlXYZ from 'ol/source/XYZ';
import OlTileLayer from 'ol/layer/Tile';
import OlVectorLayer from 'ol/layer/Vector';
import OlVectorSource from 'ol/source/Vector';
import OlView from 'ol/View';
import Style from 'ol/style/Style';
import Icon from 'ol/style/Icon';
import { Observable } from 'rxjs';
import { IOperationMetadata } from '../../../model/dataset.model';
import { MapAbstractService } from '../../services/map/map-abstract.service';
import { AwgSharedServiceService } from '../../services/awg-shared-service.service';
import { ActivatedRoute } from '@angular/router';
import { ISubscription } from 'rxjs/Subscription';
import { IntegrationService } from '../../services/integration.service';
import { TokenService } from '../../services/token.service';
import { MetadataService } from '../../services/metadata.service';
declare var $: any;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class MapComponent implements OnInit, OnDestroy,AfterViewInit {
  @Input('source') sourceDataset: String;
  @Input('height') mapHeight: String;
  @Input() datasetTable: any[];

  @ViewChild('map', {static: false}) mapElement: ElementRef;

  appcontext: string;
  paramSum: string;
  paramDataset: string;
  context: string;
  map: OlMap;
  source: OlXYZ;
  layer: OlTileLayer;
  vectorLayer: OlVectorLayer;
  vectorSource: OlVectorSource;
  view: OlView;
  showMaxRest = true;

  metadataOperation: IOperationMetadata[];

  subscription: ISubscription;

  subscriptionSelection: ISubscription;

  subscriptionEvidenzia: ISubscription;

  subscriptionMeteo: ISubscription;

  _s: Observable<any>;

  list: any;

  paramEcql: string;

  extent: any;

  zoomToExtentOnInit: boolean;
  zoomToExtentOnFilter: boolean;
  currentButton:boolean=true;
  meteoAttivo:boolean=false;
  constructor(private mapService: MapAbstractService,
    private tokenService: TokenService,
    private awgSharedService: AwgSharedServiceService,
    private metadataService: MetadataService,
    private integrationService: IntegrationService,
    private activatedRoute: ActivatedRoute) {

  }
  ngAfterViewInit(): void {
    // setTimeout(() => {
     
      // if (this.mapService.map){
      // this.mapService.map.setTarget(null);
      // this.mapService.map.setTarget('mapViewer');
    // }
    // },2000);
  }


  ngOnInit() {
    this.activatedRoute.data.subscribe(data => {
      this.appcontext = data.dataset;
      if(this.appcontext == 'ricercacuaa')
      this.showMaxRest = false;
      this.metadataService.callBackend(this.appcontext).subscribe(data => {
        if (data && data.body) {

          this.context = data.body.appcontext;
        //  console.log(this.appcontext,this.context)
          if (this.appcontext === this.context)
            this.awgSharedService.startAwgService(this.appcontext);
        }
      });

    });

    this.subscription = this.integrationService.finishFilteredData$.subscribe((obj) => {
      if (obj.layers && obj.layers.length > 0) {
        obj.layers.forEach(layer => {
          if (layer && layer.ecql != "") {
            
            this.mapService.setInitView(obj.extent);
            this.mapService.updateParamstoAllWMS(obj.layers);
            this.mapService.removeLayer(layer.layerName+'Cluster');
            this.mapService.removeLayer('isolericerca'+'Cluster');
            if(layer.ecql !="(id_pcg_vers in ('3'))" && layer.feature){
              this.mapService.aggiungiVector(layer.layerName,layer.feature);
            }
          } 
        });
        this.mapService.setZoomBing();
      } else {
        this.mapService.setInitView(obj.extent);
      }

    });
    this.subscriptionEvidenzia = this.integrationService.evidenziaPoligono$.subscribe((obj) => {
            this.mapService.removeLayerStartsWith('Poligono');
            if(obj.coordinate ){
              for(var i=0;i<obj.coordinate.length;i++){
                var multipoligono=JSON.parse(obj.coordinate[i]);
                this.mapService.aggiungiPoligono('Poligono'+i,multipoligono.coordinates);
            }
          }
        });
    this.subscriptionSelection = this.integrationService.finishSelectionData$.subscribe((obj) => {
      obj.layers.forEach(layer => {
        if (layer && layer.ecql != "") {
          this.mapService.setInitView(obj.extent);
          this.mapService.updateParamstoAllWMS(obj.layers);
        }

      });

    });
    this.startDate=this.threeHoursAgo();
    this.subscriptionMeteo= this.mapService.meteoActive$.subscribe((obj) => {

      this.meteoAttivo=this.mapService.getMeteoAttivo();
      if(!this.meteoAttivo)
        this.stop();
  });

    this.extent = this.awgSharedService.defaultExtent;
    this.mapService.createMap();
    console.log('INIT MAP',this.extent)



    if (this.extent){
      this.mapService.setInitView(this.extent);
      
    }
  }


  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionEvidenzia.unsubscribe();
    window.clearInterval(this.animationId);

  }

  public updateMap() {
    this.mapService.map.updateSize();
  }

  onSearchResult(list) {
    this.list = list;
  }

  showHideFiltri(toggle?: boolean) {

    $('#widgetContainer').toggle();
    $('#mapViewer').hasClass("dss-map-width-resize") ? $('#mapViewer').removeClass('dss-map-width-resize') : $('#mapViewer').addClass('dss-map-width-resize');
    if ($('#view').hasClass("thirteen wide column")) {
      $('#view').removeClass('thirteen wide column');
      $('#view').addClass('sixteen wide column');
    } else if ($('#view').hasClass("sixteen wide column")) {
      $('#view').removeClass('sixteen wide column');
      $('#view').addClass('thirteen wide column');
    }
    this.mapService.map.updateSize();
  }
  showFiltri() {

    $('#widgetContainer').show();
    $('#mapViewer').hasClass("dss-map-width-resize") ? $('#mapViewer').removeClass('dss-map-width-resize') : $('#mapViewer').addClass('dss-map-width-resize');
    this.mapService.map.updateSize();

  }


  createMarkerStyle() {
    return new Style({
      image: new Icon(
        {
          anchor: [0.5, 46],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          color: undefined,
          src: 'assets/images/map-marker.png'
        }
      )
    });
  }

  toggleFeatureView(){
    this.integrationService.changeCurrentView2();
    if(this.currentButton==true)
    this.currentButton=false;
    else
    this.currentButton=true;
  }


  //animazione meteo


   startDate:Date;
   frameRate:number = 0.3; // frames per second
   animationId:any = null;

   threeHoursAgo() {
     var dataTreOre=new Date(Math.round(Date.now() / 3600000) * 3600000 - 3600000 * 3);
    return dataTreOre;
  }
  
  updateInfo(info:string) {
  var el = document.getElementById('info');
  el.innerHTML =info;
}

 setTime() {
  this.startDate.setMinutes(this.startDate.getMinutes() + 30);
  if (this.startDate > new Date()) {
    this.startDate = this.threeHoursAgo();
  }

  if(this.mapService.getLayerByName("meteocorpo") && this.mapService.getLayerByName("meteocorpo").get('visible'))
    this.mapService.getLayerByName("meteocorpo").getSource().updateParams({'TIME': this.startDate.toISOString()});
  if(this.mapService.getLayerByName("meteouso") && this.mapService.getLayerByName("meteouso").get('visible'))
    this.mapService.getLayerByName("meteouso").getSource().updateParams({'TIME': this.startDate.toISOString()});
  this.updateInfo( this.startDate.toLocaleString());
}


 stop  () {
  if (this.animationId !== null) {
    window.clearInterval(this.animationId);
    this.animationId = null;
  }
};

 play () {
  stop();
  this.updateInfo("Starting...");
  this.animationId = window.setInterval(() => {
    this.setTime(); 
  }, 1000 /this.frameRate);
};








}
